/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "@/src/assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "@/src/assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "@/src/assets/icons/traffic/toggleable/IconShakeHands";

const HowItWorksSectionCivilLaw = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall schildern",
          description: "Sie schildern Ihren Fall und können Unterlagen hochladen.",
          icon: PenIcon,
        },
        {
          title: "2. Direkt Hilfe erhalten",
          description:
            "Wünschen Sie telefonische Beratung oder sollen auch rechtliche Schritte eingeleitet werden? Sie entscheiden und erhalten direkt professionelle Hilfe.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Weitere Schritte einleiten",
          description: "Wir prüfen Ihren Fall und setzen uns dafür ein, dass Sie zu Ihrem Recht gelangen!",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionCivilLaw;
